import * as React from "react";
import Vimeo from "@u-wave/react-vimeo";
import _ from "lodash";
import styled from "styled-components/native";

import { Video } from "../../types";
import { Info } from "../../styled-component";

const Container = styled(Info)`
  height: 117px;
  width: 200px;
`;

const vimeoRegex = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/;

export interface VideoPreviewProps {
  url?: Video["url"];
}

function VideoPreview({ url }: VideoPreviewProps) {
  const video = React.useMemo(() => {
    if (url) {
      const match = vimeoRegex.exec(url);
      return _.get(match, [0]);
    }
  }, [url]);

  return (
    <Container alignItems="center" justifyContent="center">
      {video && (
        <Vimeo
          video={video}
          width={200}
          onError={(err) => {
            console.log(err);
          }}
        />
      )}
    </Container>
  );
}

export default VideoPreview;
